// extracted by mini-css-extract-plugin
module.exports = {"frame":"Frame_frame__1BcBJ","frame--circle":"Frame_frame--circle__3_UE7","frame--rounded-square":"Frame_frame--rounded-square__AIZqw"};